<template>
  <div >
     <center>
      <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
      <v-container fluid>
      <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-row dense>
        <v-col style="padding-right: 8px;padding-left: 8px;">

            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>
            </v-card>
            <v-card-text>
                <v-card
                  class="mx-auto ma-5"
                  color="#1B447C"
                  dark
                  max-width="400"
                >
                <span class="text-h6 font-weight-light">ข้อมูลพนักงาน</span>
                </v-card>
                <v-row>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="require('@/assets/iconMenu/menu_11.png')" @click="GoInfomation()"></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src=" require('@/assets/iconMenu/menu_12.png')" @click="GoFamily()"></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="require('@/assets/iconMenu/menu_13.png')" @click="GoUpdateAddress()"></v-img>
                </v-col>
                </v-row>
            </v-card-text>

        </v-col>
      </v-row>
    </v-container>
     </center>
  </div>
</template>
<script>
import axios from 'axios'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'Event',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      profile: [],
      dataReady: true,
      imageHeadHRM: '',
      imageUrlBack: '',
      imageUrlActivity: '',
      imageUrlPersonalInfo: '',
      imageUrlFamilyInfo: '',
      imageUrlAddressInfo: '',
      imageUrlComingSoon: ''
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.profile.empImageUrl = this.profile.empImageUrl
    // this.imageHeadHRM = require('@/assets/Cover_Line_Pansook.jpg')
    // this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    // this.imageUrlActivity = require('@/assets/punsukText.png')
    // this.imageUrlPersonalInfo = require('@/assets/infoImg.png')
    // this.imageUrlFamilyInfo = require('@/assets/familyImg.png')
    // this.imageUrlAddressInfo = require('@/assets/addressImg.png')
    // this.imageUrlComingSoon = require('@/assets/Icon/ComingSoon.jpg')
    this.dataReady = false
    // this.getDataByFamily()
  },
  methods: {

    async getDataByFamily () {
      this.dataFamily = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/event_punsuk/getDataFamily?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
    },
    Home () {
      this.$router.push('/Liff/Home')
    },
    GoWelfare () {
      this.$router.push('/Liff/SocialInsurance')
    },
    GoActivityPage () {
      this.$router.push('/Liff/RegisterEvent')
    },
    GoFamily () {
      this.$router.push('/Liff/EmpFamily')
    },
    GoInfomation () {
      this.$router.push('/Liff/EmpInfomation')
    },
    GoUpdateAddress () {
      this.$router.push('/Liff/EmpAddress')
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/HomeEmployee.vue